import AnonymousUserService from "./anonymousUser.class.js";
import { preserveAppsFlyerId, preserveUtmParams } from "./params.helpers.js";
import {
  shouldUpdateAttributes,
  updateCartAttributes,
  watchCartChanges,
} from "./tracking.helpers.js";
import { hideTruspilotWidgetsWithoutReviews } from "./trustpilot.helpers.js";

// UTM Params
preserveUtmParams();

// AppsFlyer
preserveAppsFlyerId();

AnonymousUserService.init();

AnonymousUserService.isReady(function () {
  // Update cart attributes, only on an existing cart: writing without one
  // makes Shopify create a cart that races the ones created by other apps
  const hasCart =
    window.tracking.cart_item_count > 0 ||
    Object.keys(window.tracking.cart_attributes).length > 0;

  if (hasCart && shouldUpdateAttributes()) {
    updateCartAttributes();
  }

  // Add the attributes as soon as a cart is created or changed, by any script
  watchCartChanges();
});

// Trustpilot
hideTruspilotWidgetsWithoutReviews();
